"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var interpreter_utils_1 = require("../../../interpreter-utils");
var __1 = require("../../..");
var lodash_1 = require("lodash");
var ConditionReadingService = /** @class */ (function () {
    function ConditionReadingService() {
        this.reader = new __1.GroupingConditionReader();
    }
    ConditionReadingService.extractFromObject = function (conditionObject) {
        var conditionValues = lodash_1.values(conditionObject);
        if (conditionValues.length !== 1) {
            throw new Error('condition was not parsed properly');
        }
        var potentialCondition = conditionValues[0];
        if (lodash_1.isFunction(potentialCondition)) {
            return potentialCondition;
        }
        else {
            throw new Error('condition was not parsed properly');
        }
    };
    ConditionReadingService.prototype.readCondition = function (conditionObject) {
        var _this = this;
        return conditionObject && !lodash_1.isEmpty(conditionObject) ?
            ConditionReadingService.extractFromObject(interpreter_utils_1.traverseObject(conditionObject, function (key, value) {
                return _this.reader.read(key, value);
            })) : undefined;
    };
    return ConditionReadingService;
}());
exports.ConditionReadingService = ConditionReadingService;
//# sourceMappingURL=condition-reading.service.js.map